export const EFormFields = {
	name: 'name',
	isShared: 'isShared',
} as const;
